<div class="modal fade" id="claimsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="claimsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header" [ngClass]="{'navbar-homolog' : !production, 'bg-primary' : production}">
                <h5 class="modal-title text-white" id="claimsModalLabel">
                    <label>Acessos</label>
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <label>Perfil: {{this.credentials.Profile}}</label>
                </div>

                <div class="row">
                    <div class=" table-responsive">
                        <table class="table table-bordered align-items-center table-flush">
                            <thead>
                                <tr>
                                    <th>Acesso</th>
                                    <th>Permissões</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Filiais</td>
                                    <td>{{this.credentials.CompaniesDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Linhas de Produção</td>
                                    <td>{{this.credentials.LineOfProductsDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Unidades de Venda</td>
                                    <td>{{this.credentials.UnitsOfSaleDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Grupos Economicos</td>
                                    <td>{{this.credentials.EconomicGroupsDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Módulos</td>
                                    <td>{{this.credentials.ModulesDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Clientes</td>
                                    <td>{{this.credentials.CustomersDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Grupos de Permissão</td>
                                    <td>{{this.credentials.GroupsOfPermissionDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Mercados</td>
                                    <td>{{this.credentials.MarketsDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Departamentos</td>
                                    <td>{{this.credentials.DepartmentsDescription}}</td>
                                </tr>
                                <tr>
                                    <td>Centros de Custos</td>
                                    <td>{{this.credentials.CostCentersDescription}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>